/**
 * Show the currently selected revision as a little badge
 */
import { darken, Pill } from '@mantine/core'

import { type RevisionSet } from '#choo-app/lib/editor/plugins/revisions'

type RevisionPillProps = Pick<RevisionSet, 'pageColor' | 'textColor' | 'label'>

export const RevisionPill = (props: RevisionPillProps) => {
  'use memo'

  return (
    <Pill
      bg={props.pageColor}
      c={darken(props.textColor, 0.7)}
      size="md"
      radius="sm"
    >
      {props.label}
    </Pill>
  )
}
